import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentSchema,
  getApartmentSchemaWithAdditionalFields,
} from "./apartment";
import { getLeaseSchemaAdditionalFields, leaseSchema } from "./lease";
import { getSubletSchemaAdditionalFields, subletSchema } from "./sublet";

export const leaseWithApartmentAndSubletsSchema = leaseSchema.extend({
  apartment: apartmentSchema,
  sublets: z.array(subletSchema),
  issueCount: z.number().int().nonnegative().default(0),
});

export type LeaseWithApartmentAndSublets = z.infer<
  typeof leaseWithApartmentAndSubletsSchema
>;

export function getLeaseWithApartmentAndSubletsSchemaWithAdditionalFields(additionalFields: {
  lease: typeof additionalDataSchema;
  sublet: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof leaseWithApartmentAndSubletsSchema {
  return getLeaseSchemaAdditionalFields(additionalFields).extend({
    apartment: getApartmentSchemaWithAdditionalFields(additionalFields),
    sublets: z.array(getSubletSchemaAdditionalFields(additionalFields)),
    issueCount: z.number().int().nonnegative().default(0),
  });
}
